import { render, staticRenderFns } from "./firstPause.vue?vue&type=template&id=c74d1736&scoped=true&"
import script from "./firstPause.vue?vue&type=script&lang=js&"
export * from "./firstPause.vue?vue&type=script&lang=js&"
import style0 from "./firstPause.vue?vue&type=style&index=0&id=c74d1736&lang=scss&scoped=true&"
import style1 from "./firstPause.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74d1736",
  null
  
)

export default component.exports